module.exports = __webpack_public_path__ + "static/img/s146.e2a4833f.png";